import { Trans, useTranslation } from "react-i18next";
import CodeBlock from "../components/CodeBlock";

export default function GiveawayCard() {
  const { t } = useTranslation();

  return (
    <article>
      <h1>{t("giveawayCard.title")}</h1>
      <p>{t("giveawayCard.intro")}</p>

      <CodeBlock title="giveawayImage()">{`import { giveawayImage } from "kira-arts";

const buffer = await giveawayImage("Nitro Boost x3", {
  guildId,
  hostId: interaction.user.id,
  winnersCount: 3,
  endsAt: Date.now() + 24 * 60 * 60 * 1000,
  useRoleColor: true,
});`}</CodeBlock>

      <p>
        <Trans i18nKey="giveawayCard.hostNote" components={[<code key="0" />, <code key="1" />]} />
      </p>

      <h2>{t("giveawayCard.optionsTitle")}</h2>
      <CodeBlock title="GiveawayOptions">{`hostId?: string;
hostName?: string;
hostAvatar?: string;
winnersCount?: number;
winnerIds?: string[];
status?: "active" | "ended";
endsAt?: Date | string;
endedText?: string;
description?: string;
accentColor?: string;
borderColor?: ColorInput;
removeBorder?: boolean;
useNitroTheme?: boolean;
useRoleColor?: boolean;
customBackground?: string;
prizeColor?: string;
hostColor?: string;
guildId?: string;
bypassCache?: boolean;
localDateType?: string;
theme?: KiraThemeName;
participantsCount?: number;`}</CodeBlock>

      <h2>{t("giveawayCard.statusTitle")}</h2>
      <p>
        <Trans
          i18nKey="giveawayCard.statusNote"
          components={[<code key="0" />, <code key="1" />, <code key="2" />, <code key="3" />]}
        />
      </p>

      <CodeBlock title="ended giveaway">{`const buffer = await giveawayImage("Nitro Boost x3", {
  guildId,
  status: "ended",
  winnerIds: ["111111111111111111", "222222222222222222"],
});`}</CodeBlock>

      <p>
        <Trans
          i18nKey="giveawayCard.localeNote"
          components={[<code key="0" />, <code key="1" />, <code key="2" />]}
        />
      </p>

      <h2>{t("giveawayCard.winnersTitle")}</h2>
      <p>
        <Trans
          i18nKey="giveawayCard.winnersNote"
          components={[<code key="0" />, <code key="1" />]}
        />
      </p>

      <h2>{t("giveawayCard.colorOptionsTitle")}</h2>
      <p>
        <Trans
          i18nKey="giveawayCard.colorNote"
          components={[<code key="0" />, <a key="1" href="/docs/kira-arts/color-system" />]}
        />
      </p>
    </article>
  );
}
